export const SET_CRONOGRAMA_AULA = 'SET_CRONOGRAMA_AULA'
export const SET_CRONOGRAMAS_AULA = 'SET_CRONOGRAMAS_AULA'
export const ADD_CRONOGRAMAS_AULA = 'ADD_CRONOGRAMAS_AULA'
export const UPDATE_CRONOGRAMAS_AULA = 'UPDATE_CRONOGRAMAS_AULA'
export const REMOVE_CRONOGRAMAS_AULA = 'REMOVE_CRONOGRAMAS_AULA'
export const OPEN_CRONOGRAMA_AULA = 'OPEN_CRONOGRAMA_AULA';
export const CLOSE_CRONOGRAMA_AULA = 'CLOSE_CRONOGRAMA_AULA';